//cookie name
export const CookieName = {
  USERTOKEN: 'USERTOKEN',
  USERTEMPTOKEN: 'USERTEMPTOKEN',
  USERNAME: 'USERNAME',
  USEREMAIL: 'USEREMAIL',
  USERIMG: 'USERIMG',
  USERMOBILE: 'USERMOBILE',
  LOGINTYPE: 'LOGINTYPE',
  GOOGLE: 'GOOGLE',
  OTP: 'OTP',
};

export function setCookie(name, value, days) {
  var expires = '';
  // console.log("setting cookies....");
  if (days) {
    var date = new Date();
    if (name === 'SearchClicked') {
      date.setTime(date.getTime() + days * 60 * 1000); // its in Minutes for Ticket Block
    } else {
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    }

    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

export function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
